import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput, MatInputModule } from '@angular/material/input';
import { MachineListService } from '../../services/machine-list/machine-list.service';
import { MachineListDto } from '../../models/machines/machine-list-dto';

import { MatIconModule } from '@angular/material/icon';
import { MachineListFilter } from '../../models/machines/machine-list-filter';
import { LocalStorageService } from '../../services/localstorage/local-storage.service';
import { FilterButtonComponent } from "../filter-button/filter-button.component";
import { FilterInputChipsComponent } from '../filter-input-chips/filter-input-chips.component';

@Component({
  selector: 'app-machine-list-filter',
  imports: [MatFormField, MatLabel, ReactiveFormsModule, FormsModule, MatInput, MatIconModule, MatInputModule, FilterButtonComponent, FilterInputChipsComponent],
  templateUrl: './machine-list-filter.component.html',
  styleUrl: './machine-list-filter.component.scss',
  standalone: true
})
export class MachineListFilterComponent {
  filterValues!: MachineListFilter;

  private machines: MachineListDto[] = [];
  allMachineTypes: string[] = [];
  allProductionTechnicianAreas: string[] = [];
  allProductionLeaders: string[] = [];
  allStatuses: string[] = [];
  allOwnerTypes: string[] = [];
  allHighPrecisionCraneTipCoordinateValues: string[] = [];
  allRtkValues: string[] = [];
  allSchoolForwarderValues: string[] = [];
  allGrotForwarderValues: string[] = [];
  allDemoMachineValues: string[] = [];
  searchTerm: string = '';

  constructor(@Inject(PLATFORM_ID) private platformId: Object,
    private machineListService: MachineListService,
    private localStorage: LocalStorageService) {
    this.filterValues = this.localStorage.getMachineFilter();

    this.machineListService.data$.subscribe(async machineList => {
      this.machines = machineList ? machineList : [];
      if (this.machines) {
        this.initializeFilters();
      }
    })
  }

  ngAfterViewInit() {
    this.initializeFilters();
  }

  async initializeFilters() {
    this.allMachineTypes = [...new Set(this.machines.map(wo => wo.baseInfo.machineTypeText).filter(v => v))].sort();

    this.allProductionTechnicianAreas = [...new Set(this.machines.flatMap(wo => wo.baseInfo.productionTechnicianAreas).filter(v => v))].sort();
    this.allProductionLeaders = [...new Set(this.machines.flatMap(wo => wo.baseInfo.productionLeaders).filter(v => v))].sort();
    this.allOwnerTypes = [...new Set(this.machines.map(wo => wo.baseInfo.ownerType).filter(v => v))].sort();
    this.allStatuses = [...new Set(this.machines.map(wo => wo.baseInfo.machineStatusText).filter(v => v))].sort();
    this.allHighPrecisionCraneTipCoordinateValues = [...new Set(this.machines.map(wo => wo.equipmentInfo.hasHighPrecisionCraneTipCoordinateText).filter(v => v))].sort();
    this.allRtkValues = [...new Set(this.machines.map(wo => wo.equipmentInfo.hasRtkText).filter(v => v))].sort();
    this.allSchoolForwarderValues = [...new Set(this.machines.map(wo => wo.baseInfo.isSchoolForwarderText).filter(v => v))].sort();
    this.allGrotForwarderValues = [...new Set(this.machines.map(wo => wo.baseInfo.isGrotForwarderText).filter(v => v))].sort();
    this.allDemoMachineValues = [...new Set(this.machines.map(wo => wo.baseInfo.isDemoMachineText).filter(v => v))].sort();
    this.searchTerm = this.filterValues.search.length === 1 ? this.filterValues.search[0].value : '';

    this.applyFilter();
  }

  applyFilter() {
    if (this.filterValues.search.length === 0) {
      this.searchTerm = '';
    }

    this.filterValues = { ...this.filterValues };
    this.machineListService.applyFilter(this.filterValues);
    this.localStorage.saveMachineFilter(this.filterValues);
  }

  compareWith(compare1: any, compare2: any): boolean {
    return compare1 && compare2 && compare1.id === compare2.id;
  }

  filterSelectableValuesByQuery() {
    const hasSearchTerm = (this.searchTerm ?? '').trim().length > 0;

    if (!hasSearchTerm) {
      this.filterValues.search = [];
      this.applyFilter();
      return;
    }

    this.searchTerm = this.searchTerm.trim();

    if (!this.filterValues.search || this.filterValues.search.length === 0) {
      this.filterValues.search = [{ value: this.searchTerm, activated: true }];
    } else {
      this.filterValues.search[0].value = this.searchTerm;
      this.filterValues.search[0].activated = true;
    }

    this.applyFilter();
  }
}
